/**
 * @generated SignedSource<<44081a4b31b0bfd28024471e32793021>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type fetchTtsQuery$variables = {
  lang: string;
  speakingRate?: number | null;
  text: string;
  useCache?: boolean | null;
  voiceId?: string | null;
};
export type fetchTtsQuery$data = {
  readonly tts: {
    readonly id: string;
    readonly speech: string;
    readonly voiceId: string;
  } | null;
};
export type fetchTtsQuery = {
  response: fetchTtsQuery$data;
  variables: fetchTtsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "speakingRate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "text"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useCache"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voiceId"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lang",
        "variableName": "lang"
      },
      {
        "kind": "Variable",
        "name": "speakingRate",
        "variableName": "speakingRate"
      },
      {
        "kind": "Variable",
        "name": "text",
        "variableName": "text"
      },
      {
        "kind": "Variable",
        "name": "useCache",
        "variableName": "useCache"
      },
      {
        "kind": "Variable",
        "name": "voiceId",
        "variableName": "voiceId"
      }
    ],
    "concreteType": "Tts",
    "kind": "LinkedField",
    "name": "tts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "speech",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "voiceId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchTtsQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "fetchTtsQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "638a677a4437ad8ed340081737b41c53",
    "id": null,
    "metadata": {},
    "name": "fetchTtsQuery",
    "operationKind": "query",
    "text": "query fetchTtsQuery(\n  $text: String!\n  $lang: String!\n  $speakingRate: Float\n  $voiceId: String\n  $useCache: Boolean\n) {\n  tts(text: $text, lang: $lang, speakingRate: $speakingRate, voiceId: $voiceId, useCache: $useCache) {\n    id\n    speech\n    voiceId\n  }\n}\n"
  }
};
})();

(node as any).hash = "518aa197810d405e228f972985df4bdc";

export default node;
